import { Tab, Tabs } from "@mui/material";
import { AppDomains } from "models/Permission/AppDomains";
import React from "react";
import { navLinkProps } from "utils/useUnsavedChangesNavigationGuard";

type Props = {
    selected: number;
    onChange: (tab: number) => void;
    tabs: Array<ITab>;
};

export interface ITab {
    tabLabel:
        | string
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    route: string;
    routePrefix?: string;
    domain: AppDomains;
    domainAction?: string;
    icon?:
        | string
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | undefined;
    newDomainName?: string;
    hideInNavbar?: boolean;
}

function NavMenu(props: Props) {
    return (
        <Tabs
            value={
                props.tabs && props.selected >= props.tabs.length
                    ? false
                    : props.selected
            }
            variant={"scrollable"}
            scrollButtons="auto"
            allowScrollButtonsMobile
            indicatorColor="primary"
            textColor="primary"
            onChange={(_, newValue) => props.onChange(newValue)}
            sx={(theme) => ({
                flex: 1,
                gap: 1,
                ml: 2.5,
                mr: 1,
                height: "100%",

                "& .MuiTabs-flexContainer": {
                    height: "100%",
                },

                ".MuiTabScrollButton-root": {
                    color: theme.palette.black.light,
                    mr: -1,

                    "&.Mui-disabled": {
                        maxWidth: 0,
                    },
                },
            })}
        >
            {props.tabs
                ? props.tabs.map((tab) => {
                      const id = "tab-" + tab.tabLabel.toString();
                      return (
                          <Tab
                              key={id}
                              label={tab.tabLabel}
                              id={id}
                              // Navigates imperatively (no <a>) — lets an unsaved-changes guard find this click.
                              {...navLinkProps}
                              sx={(theme) => ({
                                  fontSize: "13px",
                                  textTransform: "initial",
                                  lineHeight: "20px",
                                  opacity: 0.5,
                                  color: theme.palette.black.main,
                                  px: 2,
                                  py: 1,
                                  minWidth: "fit-content",

                                  "&.Mui-selected": {
                                      opacity: 1,
                                      fontWeight:
                                          theme.typography.fontWeightBold,
                                  },
                              })}
                          />
                      );
                  })
                : ""}
        </Tabs>
    );
}

export default NavMenu;
